import { create } from 'zustand';

const useUsageStore = create((set, get) => ({
    usage: null,
    isLoading: true,
    setUsage: (usage) => set({ usage }),
    setIsLoading: (isLoading) => set({ isLoading })
}));

export default useUsageStore;
